import CalendarIcon from './component'

export default CalendarIcon
